import { render, staticRenderFns } from "./CampaignViewHeader.vue?vue&type=template&id=2c1c0dc1"
import script from "./CampaignViewHeader.vue?vue&type=script&lang=js"
export * from "./CampaignViewHeader.vue?vue&type=script&lang=js"
import style0 from "./CampaignViewHeader.vue?vue&type=style&index=0&id=2c1c0dc1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports